module.exports = __webpack_public_path__ + "合作.png?d8d1df911c6d71f76a8c6fa1de917342";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作.png
// module id = 642
// module chunks = 0